import rjsfValidateFormData from "@rjsf/core/lib/validate";

import deduplicate from './deduplicate';
import { invertMap, mapObject } from './mapObject';

export const ERRORS_KEY = '__errors';


function validateFormData(formObject, schema, objectMap, customFormats){
    const formData = mapObject(formObject, invertMap(objectMap));
    return cleanErrors(rjsfValidateFormData(formData, schema, undefined, undefined, undefined, customFormats).errorSchema)
}


function cleanErrors(errorSchema){
    if (!errorSchema) return [];

    const cleaned = {};
    const stack = [["", cleaned, errorSchema]];
    while (stack.length) {
        const [prefix, dst, current] = stack.shift();
        Object.entries(current).forEach(([key, value]) => { if (key === ERRORS_KEY) {
            value = value.filter(x => x !== 'should be equal to constant');
            if (prefix && value.length) {
                dst[key] = deduplicate(value);
            }
        } else {
            dst[key] = {};
            stack.push([key, dst[key], value]);
        }});
    }

    return cleaned;
}

export default validateFormData;